export default __webpack_public_path__ + "static/2-no-internet-connection-81659cab04812e31b95f78958f33b475.png";